// composables/useClient.ts
import { inject } from 'vue'
import type { MBPClient } from '@/services/client/api'

export const CLIENT_INJECTION_KEY = Symbol('client')

export function useClient(): MBPClient {
    const client = inject<MBPClient>(CLIENT_INJECTION_KEY)
    if (!client) {
        throw new Error('Client was not provided')
    }
    return client
}